import { Link } from "gatsby"
import * as React from "react"
import Fade from "react-reveal/Fade"
import AnchorTop from "../../images/anchor-top.svg"

const SpecificationsByType = ({ yachtData }) => {
    const { specification, type } = yachtData

    return type === "main" ? (
        <>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Capacity</div>

                <div className="spec-value">{yachtData.capacity} + 1 people</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Length</div>

                <div className="spec-value">{specification.length}m</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Beam</div>

                <div className="spec-value">{specification.beam}m</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Draft</div>

                <div className="spec-value">{specification.draft}m</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Fuel capacity</div>

                <div className="spec-value">{specification.fuel}l</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Max speed</div>

                <div className="spec-value">{specification.speed}+ knots</div>
            </div>
            {yachtData.beths && (
                <div className="spec-card-container d-flex flex-row align-items-center">
                    <div className="spec-label">Berths</div>

                    <div className="spec-value">{specification.berths}</div>
                </div>
            )}
        </>
    ) : (
        <>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Capacity</div>

                <div className="spec-value">{yachtData.capacity} + 3 people</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Length</div>

                <div className="spec-value">{specification.length}m</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Beam</div>

                <div className="spec-value">{specification.beam}m</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Sleeping capacity</div>

                <div className="spec-value">{specification.sleeping} guests</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Cruise speed</div>

                <div className="spec-value">{specification.cruiseSpeed} knots</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Top speed</div>

                <div className="spec-value">{specification.topSpeed} knots</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Engines</div>

                <div className="spec-value text-end">{specification.engines}</div>
            </div>
            <div className="spec-card-container d-flex flex-row align-items-center">
                <div className="spec-label">Fuel consumption</div>

                <div className="spec-value">{specification.fuelConsumption}</div>
            </div>
        </>
    )
}

const YachtDetails = ({ yachtData }) => {
    const { description, features } = yachtData

    return (
        <div className="container-xxl yacht-details-container">
            <Fade delay={700} duration={1500}>
                <div className="row ">
                    <div className="col-12 mb-3 col-md-6 mb-0 d-flex flex-column align-items-center">
                        <div className="spec-card">
                            <span className="spec-title mb-3">Specification</span>
                            <SpecificationsByType yachtData={yachtData} />
                        </div>
                    </div>

                    <div className="col-12 col-md-6 position-relative pe-inside">
                        <img src={AnchorTop} className="yacht-anchor-top d-none d-md-block" alt="Anchor top vector" />
                        <div className="mb-yach-desc">
                            <h2 className="meet-text">Meet {yachtData.name}</h2>
                            <p>{description.first}</p>
                            <p>{description.second}</p>
                            {description?.third && <p>{description.third}</p>}
                        </div>

                        <div className="d-none d-md-block">
                            <h3>Features</h3>
                            <div className="row">
                                <div className="col">
                                    <ul>
                                        {features.first.map(f => (
                                            <li key={f}>{f}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col">
                                    <ul>
                                        {features.second.map(f => (
                                            <li key={f}>{f}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default YachtDetails
